var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"no-underline",attrs:{"href":("https://twitter.com/intent/tweet?url=" + _vm.fullUrl + "&hashtags=continent"),"data-size":"large","target":"_blank"}},[_c('span',{staticClass:"icon icon-twitter"})])}
var staticRenderFns = []

export { render, staticRenderFns }